/**
 * Short list of country dial codes + names used by the registration forms.
 * Codes are ISO 3166-1 alpha-2 (lowercase, matches the `fi-XX` class of the
 * flag-icons CSS library loaded in `index.html`).
 *
 * Ordered roughly by relevance for the Albanian market first, then EU/Balkans,
 * then the rest of the world alphabetically. Extend as needed.
 */
export const COUNTRIES = [
  { code: "al", name: "Shqipëri", dial: "+355" },
  { code: "xk", name: "Kosovë", dial: "+383" },
  { code: "mk", name: "Maqedonia e Veriut", dial: "+389" },
  { code: "me", name: "Mali i Zi", dial: "+382" },
  { code: "gr", name: "Greqi", dial: "+30" },
  { code: "it", name: "Itali", dial: "+39" },
  { code: "de", name: "Gjermani", dial: "+49" },
  { code: "at", name: "Austri", dial: "+43" },
  { code: "ch", name: "Zvicër", dial: "+41" },
  { code: "fr", name: "Francë", dial: "+33" },
  { code: "es", name: "Spanjë", dial: "+34" },
  { code: "pt", name: "Portugali", dial: "+351" },
  { code: "nl", name: "Holandë", dial: "+31" },
  { code: "be", name: "Belgjikë", dial: "+32" },
  { code: "lu", name: "Luksemburg", dial: "+352" },
  { code: "gb", name: "Mbretëria e Bashkuar", dial: "+44" },
  { code: "ie", name: "Irlandë", dial: "+353" },
  { code: "se", name: "Suedi", dial: "+46" },
  { code: "no", name: "Norvegji", dial: "+47" },
  { code: "dk", name: "Danimarkë", dial: "+45" },
  { code: "fi", name: "Finlandë", dial: "+358" },
  { code: "pl", name: "Poloni", dial: "+48" },
  { code: "cz", name: "Republika Çeke", dial: "+420" },
  { code: "sk", name: "Sllovaki", dial: "+421" },
  { code: "hu", name: "Hungari", dial: "+36" },
  { code: "ro", name: "Rumani", dial: "+40" },
  { code: "bg", name: "Bullgari", dial: "+359" },
  { code: "hr", name: "Kroaci", dial: "+385" },
  { code: "si", name: "Slloveni", dial: "+386" },
  { code: "rs", name: "Serbi", dial: "+381" },
  { code: "ba", name: "Bosnjë-Hercegovinë", dial: "+387" },
  { code: "tr", name: "Turqi", dial: "+90" },
  { code: "us", name: "Shtetet e Bashkuara", dial: "+1" },
  { code: "ca", name: "Kanada", dial: "+1" },
  { code: "au", name: "Australi", dial: "+61" },
  { code: "ae", name: "Emiratet e Bashkuara Arabe", dial: "+971" },
  { code: "sa", name: "Arabia Saudite", dial: "+966" },
];

export const findCountry = (code) =>
  COUNTRIES.find((c) => c.code === (code || "").toLowerCase()) || COUNTRIES[0];

/** Free IP-based country detection. Returns lowercase ISO2 code or null. */
export const detectCountryFromIP = async () => {
  try {
    const res = await fetch("https://ipapi.co/json/", { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    const code = (data.country_code || "").toLowerCase();
    if (code && COUNTRIES.find((c) => c.code === code)) return code;
    return null;
  } catch {
    return null;
  }
};
